<template>
  <div>
    <label>
      <translate>Let us know why you are cancelling your subscription</translate>
      *
    </label>
    <b-form-select :options="options"
                   v-model="selected"
                   @input="(v) => $emit('input', v)"
                   required/>
  </div>
</template>

<script>
export default {
  name: "DowngradeReasonSelector",
  props: {
    value: String
  },
  data() {
    return {
      selected: null,
      options: [
        {value: null, text: this.$gettext("Please select an option")},
        {value: "unused", text: this.$gettext("I no longer use Gekko")},
        {value: "basic", text: this.$gettext("Free Basic is enough for me")},
        {value: "periodically", text: this.$gettext("I only upgrade periodically")},
        {value: "dissatisfied", text: this.$gettext("I'm dissatisfied with a recent change by Gekko")},
        {value: "other", text: this.$gettext("Other")},
      ]
    }
  }
};
</script>

<style scoped>
</style>
